import React from "react"
import {
  SettingsCard,
  SettingsCardTitle,
  SettingsCardContent,
} from "@modules/site/settings"
import { SiteSettingsSection, SiteSettingsSectionLabel } from "../constants"
import PublishReports from "./PublishReports"

export default function ReportsSection({
  siteId,
  siteName,
  permissions,
  buildsEnabled,
}) {
  return (
    <SettingsCard>
      <SettingsCardTitle>
        {SiteSettingsSectionLabel[SiteSettingsSection.Reports]}
      </SettingsCardTitle>

      <SettingsCardContent>
        <PublishReports
          siteId={siteId}
          siteName={siteName}
          permissionToEdit={permissions.sites.edit}
          buildsEnabled={buildsEnabled}
        />
      </SettingsCardContent>
    </SettingsCard>
  )
}
